export default __webpack_public_path__ + "static/media/faceta_icon_access_control.4609f540.svg";